import { Component, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { UserData } from '../../providers/user-data';

import { UserOptions } from '../../interfaces/user-options';
import { AuthProvider } from 'src/app/providers/auth.provider';
import { ToastController } from '@ionic/angular';



@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
  styleUrls: ['./signup.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignupPage {
  signup: any = { email: '', password: '', confirmPassword: '' };
  submitted = false;
  error: string;
  infoMessage: string;

  constructor(
    public router: Router,
    public userData: UserData,
    private authProvider: AuthProvider,
    public toastCtrl: ToastController,
  ) {}

  async onSignup(form: NgForm) {
    this.submitted = true;
    this.error = '';
    if (form.valid) {
      // this.router.navigateByUrl('/login');
      try {
        await this.authProvider.startLoading();
        const tempRes = await this.authProvider.signupApi(form.value);
        console.log("tempRes ", tempRes);
        await this.toastCtrl.create({
          message: 'Konto utworzone, zaloguj się teraz.',
          duration: 3000,
          position: 'bottom',
        });
        this.infoMessage = 'Konto utworzone, zaloguj się teraz.';
        this.signup = { email: '', password: '', confirmPassword: '' };
        await this.authProvider.closeLoading()

      } catch (error) {
        console.log("error", error);
        await this.authProvider.closeLoading()

        this.error = error;
        // await this.toastCtrl.create({
        //   message: error,
        //   duration: 3000,
        //   position: 'bottom',
        // });
      }
      this.submitted = false;
    }
  }

  loginPage() {
    this.router.navigateByUrl('/login');
  }
}
